import { render, staticRenderFns } from "./OrderPriceType.vue?vue&type=template&id=7a383030&scoped=true"
import script from "./OrderPriceType.vue?vue&type=script&lang=js"
export * from "./OrderPriceType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a383030",
  null
  
)

export default component.exports